import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { TableColumn } from 'src/app/components/common/common-table/common-table.component';
import { CommonDropdownComponent } from 'src/app/components/common/common-dropdown/common-dropdown.component';
import { DataSet } from 'src/app/models/report-data-set';
import { ClientService, SystemService, Utilities, WorkflowContextService, WorkflowService } from 'src/app/services';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Client } from 'src/app/models';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { Subscription } from 'rxjs';
import { DataSetsActionsComponent } from './data-sets-actions/data-sets-actions.component';
import { PagedDailyFeeReportRequest, PagedDailyFeeReportResponse } from 'src/app/models/financial-reports';
import { FilterBuilderOutput } from 'src/app/models/filter-builder';
import { DataSetInformationComponent } from './data-set-information/data-set-information.component';
import { CommonTableComponent } from 'src/app/components/common/common-table/common-table.component';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';

@Component({
  selector: 'wm-app-data-sets',
  templateUrl: './data-sets.component.html',
  styleUrls: ['./data-sets.component.css'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class DataSetsComponent implements OnInit, OnDestroy {
  loading = true;
  errorMessage = '';
  report: PagedDailyFeeReportResponse;

  showNewDataSet = false;
  datasetInfoComponent = DataSetInformationComponent;

  getDatasetInfoInputs = (row: any) => ({
    dataSetId: row.raw?.id,
    dataSetName: row.raw?.name,
    dataSetDesc: row.raw?.description
  });

  columns: TableColumn[] = [];
  rows: any[] = [];
  expandedComponentOutputs = {
    dataSetSaved: () => this.handleInlineDataSetSaved()
  };


  // newDataButton = {
  //   text: 'NEW DATA SET',
  //   disabled: false,
  //   customClass: ''
  // };

  dataSets: DataSet[];
  EMPTY_GUID = Utilities.EMPTY_GUID;

  clients: Client[];
  targetClientId?: string;
  targetName: string;
  copyDataSetId: string;
  targetForm: UntypedFormGroup;
  copyingDataSet = false;
  clientSub: Subscription;

  selectedDataSet: DataSet | null = null;

  @ViewChild('actionsTmpl', { static: true })
  actionsTmpl!: TemplateRef<any>;

  @ViewChild('dataSetsTable', { static: false })
  dataSetsTable?: CommonTableComponent;

  @ViewChild('deleteDataSetModal', { static: false })
  deleteDataSetModal!: ModalConfirmComponent;

  @ViewChild('copyDataSetModal', { static: false })
  copyDataSetModal!: ModalConfirmComponent;

  @ViewChild('publishDataSetModal', { static: false })
  publishDataSetModal!: ModalConfirmComponent;

  @Input() public sortField = 'name';
  @Input() public sortDescending = false;
  public page = {
    size: 10,
    totalElements: 0,
    totalPages: 0,
    pageNumber: 0
  };
  lastQuery = {};
  filters: FilterBuilderOutput = {};

  initializeColumns(): void {
    this.columns = [
      {
        key: 'name',
        label: 'Name',
        headerType: 'text',
        cellType: 'text',
        textColor: '#2196F3',
        expandable: true,
        width: '220px'
      },
      {
        key: 'lastPublished',
        label: 'Last Published On',
        headerType: 'text',
        cellType: 'text'
      },
      {
        key: 'action',
        label: 'Action',
        headerType: 'text',
        cellType: 'component',
        component: DataSetsActionsComponent,

        componentInputs: (row) => ({
          row: row.raw
        }),
        componentOutputs: {
          action: this.handleAction
        }
      }

    ];
  }

  handleAction = (event: { action: string; row: any }) => {
    this.onAction(event);
  };

  // Start Code added by Sanchit 04/23/2026
  modalData: any = {
    open: false,
    modalDescp: '',
    modalSubDescp: '',
    yesNoBtn: true,
    modalWidth:'auto'
  };

  clientDropdownData: any = {
    placeholder: 'Select Jurisdiction',
    options: [],
    required: true,
    style: {
      width: '100%',
      height: '40px'
    }
  };

  nameFieldData: any = {
    label: 'New Name',
    placeholder: 'Enter new dataset name',
    required: true,
    type: 'text'
  };

  currentAction: 'delete' | 'copy' | 'publish' | null = null;

  onAction(event: { action: string; row: DataSet }) {

    this.selectedDataSet = event.row;
    this.currentAction = event.action as any;

    if (event.action === 'delete') {
      this.modalData = {
        ...this.modalData,
        open: true,
        modalDescp: 'Delete Data Set',
        modalSubDescp: `Are you sure you want to delete "${event.row.name}"?`,
        yesNoBtn: true,
        okBtn: false
      };
    }

    if (event.action === 'copy') {
      this.startDataSetCopy(event.row);

      setTimeout(() => {
        this.modalData = {
          ...this.modalData,
          open: true,
          modalDescp: 'Copy Data Set',
          modalSubDescp: `Are you sure you want to copy "${event.row.name}"?`,
          yesNoBtn: true,
          okBtn: false
        };
      });
    }

    if (event.action === 'publish') {
      this.modalData = {
        ...this.modalData,
        open: true,
        modalDescp: 'Publish Data Set',
        modalSubDescp: `Are you sure you want to publish "${event.row.name}"?`,
        yesNoBtn: true,
        okBtn: false
      };
    }
  }

  confirmAction() {

    if (!this.selectedDataSet || !this.currentAction) return;

    const ds = this.selectedDataSet;
    const action = this.currentAction;

    this.modalData.open = false;

    if (action === 'delete') {
      this._workflowSvc.deleteDataSet(ds.id).subscribe(() => {
        this.loadDataSets();
        this._toastr.success(`Data set "${ds.name}" deleted`);
      });
    }

    if (this.currentAction === 'copy') {

      if (this.targetForm.invalid) {
        this._toastr.error('Please fill all required fields');
        return;
      }

      this.copyDataSet();
      return;
    }

    if (action === 'publish') {
      this._workflowSvc.publishDataSet(ds.id).subscribe(() => {
        this.loadDataSets();
        this._toastr.success(`Data set "${ds.name}" published`);
      });
    }

    this.currentAction = null;
  }

  cancelAction() {
    this.modalData.open = false;
    this.currentAction = null;
  }

  onClientChange(value: string) {
    this.targetForm.patchValue({
      targetClientId: value
    });
  }

  onNameChange(value: string) {
    this.targetForm.patchValue({
      targetName: value
    });
  }

  startDataSetCopy(ds: DataSet) {
    this.copyDataSetId = ds.id;

    const clientId = this.context?.client?.id || '';
    const name = `Copy Of - ${ds.name}`;

    this.targetForm.patchValue({
      targetClientId: clientId,
      targetName: name
    });

    this.clientDropdownData = {
      placeholder: 'Select Jurisdiction',
      required: true,
      style: {
        width: '100%',
        height: '40px'
      },
      options: (this.clients || []).map(c => ({
        label: c.name,
        value: c.id
      })),
      selectedValue: clientId   // 👈 must be here at creation time
    };

    this.nameFieldData = {
      ...this.nameFieldData,
      value: name
    };
  }
  // End Code added by Sanchit 04/23/2026

  // newDataSet(): void {
  //   if (this.newDataButton.disabled) return;

  //   this.showNewDataSet = true;

  //   this.newDataButton = {
  //     ...this.newDataButton,
  //     disabled: true,
  //     customClass: 'disabled-state'
  //   };
  // }

  // closeNewDataSet(): void {
  //   this.showNewDataSet = false;

  //   this.newDataButton = {
  //     ...this.newDataButton,
  //     disabled: false,
  //     customClass: ''
  //   };
  // }

  constructor(
    private _context: WorkflowContextService,
    private _workflowSvc: WorkflowService,
    public context: WorkflowContextService,
    private _router: Router,
    private _toastr: ToastrService,
    private _clientSvc: ClientService
  ) { }

  ngOnDestroy(): void {
    if (this.clientSub) {
      this.clientSub.unsubscribe();
      this.clientSub = null;
    }
  }


  // ngOnChanges(changes: SimpleChanges): void {
  //   console.log(changes);
  //   if(changes['datasets']){
  //     this.loadDataSets();
  //   }
  // }

  loadDataSets() {

    this.loading = true;
    this.errorMessage = '';

    const load = (clientId: string) => {

      this._workflowSvc.getDataSets(clientId).subscribe({
        next: (dataSets: any[]) => {

          this.loading = false;

          this.dataSets = dataSets as DataSet[];

          if (!dataSets || dataSets.length === 0) {
            this.rows = [];
            return;
          }

          this.rows = dataSets.map(ds => ({
            raw: ds,
            name: ds.name,

            lastPublished: ds.publishedOn
              ? new Date(ds.publishedOn).toLocaleString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                timeZone: 'America/Chicago',
                timeZoneName: 'short'
              })
              : 'Never Published',
          }));

        },

        error: () => {
          this.loading = false;
          this.errorMessage = 'Failed to load datasets. Please try again.';
        }
      });
    };

    if (this.context?.client?.id) {
      load(this.context.client.id);
    } else {
      this.clientSub = this.context.client$.subscribe(client => {
        if (client?.id) {
          load(client.id);
        }
      });
    }
  }

  handleInlineDataSetSaved() {
    this.loadDataSets();
    this.dataSetsTable?.closeExpansion();
  }

  deleteDataSet() {

    if (!this.selectedDataSet) { return; }

    const dataSet = this.selectedDataSet;

    this._workflowSvc.deleteDataSet(dataSet.id).subscribe(result => {
      if (result) {
        this.loadDataSets();
        const idx = this.dataSets.findIndex(ds => ds.id === dataSet.id);

        if (idx > -1) {

          this.dataSets.splice(idx, 1);
        }

        this._toastr.success(`Data set "${dataSet.name}" has been deleted.`);
      }
    });
  }

  // startDataSetCopy(ds: DataSet) {
  //   this.copyDataSetId = ds.id;

  //   const clientId = this.context?.client?.id || '';
  //   this.targetForm.patchValue({
  //     targetClientId: clientId,
  //     targetName: `Copy Of - ${ds.name}`
  //   });
  // }

  copyDataSet() {
    if (!this.copyDataSetId || this.targetForm.invalid) { return; }
    this.copyingDataSet = true;

    const { targetClientId, targetName } = this.targetForm.value;

    this._workflowSvc.copyDataSet({
      dataSetId: this.copyDataSetId,
      targetClientId,
      targetName
    }).subscribe(() => {
      this.copyingDataSet = false;
      this._toastr.success('Data Set Copied');
      this.loadDataSets();
    });
  }

  publishDataSet() {

    if (!this.selectedDataSet) { return; }

    const dataSet = this.selectedDataSet;

    this._workflowSvc.publishDataSet(dataSet.id).subscribe(result => {
      if (result) {
        this.loadDataSets();
        this._toastr.success(`Data set "${dataSet.name}" has been published.`);
      }
    });
  }

  ngOnInit() {

    this.modalData.onYes = () => this.confirmAction();
    this.modalData.onNo = () => this.cancelAction();

    this.initializeColumns();
    this.loadDataSets();

    // this._clientSvc.getAdminClients().subscribe(c => {
    //   this.clients = c;
    // });

    this._clientSvc.getAdminClients().subscribe(c => {
      this.clients = c;

      this.clientDropdownData = {
        ...this.clientDropdownData,
        options: (c || []).map(client => ({
          label: client.name,
          value: client.id
        }))
      };
    });

    this.targetForm = new UntypedFormGroup({
      targetClientId: new UntypedFormControl('', Validators.nullValidator),
      targetName: new UntypedFormControl('', Validators.required)
    });

    this.clientDropdownData.options = (this.clients || []).map(c => ({
      label: c.name,
      value: c.id
    }));
  }


}
